const educationalDegrees = Object.freeze({
    ILLITERATE : 'illiterate',
    PRIMARY_SCHOOL : 'primary_school',
    MIDDLE_SCHOOL  : 'middle_school',
    DIPLOMA : 'diploma',
    ASSOCIATE : 'associate',
    BACHELOR : 'bachelor',
    MASTER : 'master',
    DOCTORAL : 'doctoral',
    POST_DOCTORAL : 'post_doctoral'
});
export default educationalDegrees;